import type {
  EnumParameter,
  ScanServiceParameter,
  ScanServiceParameterOption,
} from '@witmetrics/utils';
import { findByValue } from '@witmetrics/utils/arrays';
import { PARAMETER_TYPES } from '@witmetrics/utils/constants';
import { isNullish } from '@witmetrics/utils/misc';
import { BOOLEAN_ENUM_VALUES } from './constants';

export const classes = {
  inputBody: 'justify-end',
  input: 'w-full m-0',
};

export function isBooleanEnum(
  parameter: ScanServiceParameter
): parameter is EnumParameter {
  if (parameter.type !== PARAMETER_TYPES.ENUM) return false;
  const options = (parameter as EnumParameter).options;
  if (options.length !== 2) return false;
  const values = options.map((o) => o.value).sort();
  return (
    values[0] === BOOLEAN_ENUM_VALUES.DISABLED &&
    values[1] === BOOLEAN_ENUM_VALUES.ENABLED
  );
}

export function findSelectedOption(
  parameter: EnumParameter,
  value: string | null
): ScanServiceParameterOption | null {
  if (isNullish(value)) return null;
  return findByValue(parameter.options, value) || null;
}

export function buildImagePath(imgSrc: string) {
  return `/images/relu/${imgSrc}`;
}
